import React from "react";

const Initiative = () => {
  return <div></div>;
};

export default Initiative;
